
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"50%","x2":"50%","y1":"0%","y2":"59.253%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFF"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#FFF","stop-opacity":"0"}})])]),_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#B20000","d":"M11.72 0a4.331 4.331 0 00-3.578 1.868l-.165.21-.111-.141A4.272 4.272 0 004.28 0C1.8 0 0 1.792 0 4.26 0 7.906 7.637 14 7.954 14 8.271 14 16 7.817 16 4.26 16 1.793 14.2 0 11.72 0z"}}),_c('path',{attrs:{"fill":"url(#a)","d":"M11.256 1c-1.26 0-1.983.682-2.686 1.684L8 3.422l-.547-.738C6.758 1.645 6.016 1 4.745 1 2.575 1 1 1.94 1 4.652c0 3.059 5.799 7.728 6.222 8.06.2.186.46.288.738.288.277 0 .539-.102.738-.289C9.122 12.377 15 7.745 15 4.651 15 1.682 13.425 1 11.256 1z","opacity":".318"}})])])
          )
        }
      }
    